<!-- Template -->

<template>
    <ul class="nav nav-tabs level-2" role="tablist">
        <li class="nav-item">
            <!-- <router-link class="nav-link" :class="{ active: active === 'activity' }" :to="{ name: 'Activity', params: { hospital: hospital.id } }">Activity
                <div v-if="numOfActivities > 0" class="badge">{{numOfActivities}}</div>
            </router-link> -->
            <router-link class="nav-link" :class="{ active: active === 'systems' && this.$route.name != 'System' }" :to="{ name: 'Systems', params: { hospital: id } }">Systems
                <div v-if="numOfSystems > 0" class="badge">{{numOfSystems}}</div>
            </router-link>
            <router-link class="nav-link" :class="{ active: active === 'tickets' }" :to="{ name: 'Tickets', params: { hospital: id } }">Open Tickets
                <div v-if="numOfTickets > 0" class="badge">{{numOfTickets}}</div>
            </router-link>
        </li>
    </ul>
</template>

<!-- Script -->

<script>
    export default {
        name: 'Navigation',

        data() {
            return {                
                //numOfActivities: 0,
                numOfSystems: 0,
                numOfTickets: 0
            };
        },

        props: [
            'active',
            'supportTicketsCount',
            'systemsCount',
            'id'
        ],

        watch: {
			'$route' () {
                this.update();
            },
           
            supportTicketsCount: {
                deep: true,
                immediate: true,
                handler(value) {
                    if (value) {  
                        this.numOfTickets =value;     
                    }
                }
            }
       
        },

        created(){
            this.update();
        },

        methods: {
            update() { 
                //this.numOfActivities = 0;
                this.numOfSystems = this.systemsCount;
                this.numOfTickets = this.supportTicketsCount;                
            }
        }
    }
</script>

